import { render, staticRenderFns } from "./CouponView.vue?vue&type=template&id=71ff64e0&"
import script from "./CouponView.vue?vue&type=script&lang=js&"
export * from "./CouponView.vue?vue&type=script&lang=js&"
import style0 from "./CouponView.vue?vue&type=style&index=0&id=71ff64e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports